import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/de';
import { toLower } from 'lodash';

const formats = [
  moment.ISO_8601,
  'DD/MM/YYYY',
  'MM/DD/YYYY',
  'DD-MM-YYYY',
  'MM-DD-YYYY',
  'YYYY-MM-DD',
  'YYYY-DD-MM',
  'YYYY/MM/DD',
  'YYYY/DD/MM',
];

export const isDateFormat = (inputValue) => {
  const numericStringRegex = /^\d+$/;
  // check if it is a numeric string
  if (numericStringRegex.test(inputValue)) {
    return false;
  }
  return moment(inputValue, moment.ISO_8601, true).isValid();
};

export const isDate = (inputValue) =>
  moment(inputValue, moment.ISO_8601, true).isValid();

export const formatDate = (inputValue) =>
  moment(inputValue).locale(localStorage.i18nextLng).format('LL');

export const formatDateTime = (inputValue) =>
  moment(inputValue).locale(localStorage.i18nextLng).format('LL LTS');

export const isValidDate = function (date) {
  if (toLower(date) === 'invalid date') return false;
  const newDate = toString(new Date(date));
  return toLower(newDate) !== 'invalid date';
};

export const formatDateForm = (inputValue) =>
  isDate(inputValue)
    ? moment(inputValue, formats, true).format('YYYY-MM-DD')
    : inputValue;

export const formatFristDayToStandard = (inputValue) => {
  if (inputValue && isValidDate(inputValue)) {
    const date = inputValue.split('/');
    if (date && date.length === 3) {
      const correctFormat = `${date[1]}/${date[0]}/${date[2]}`;

      const convertedTime = moment(correctFormat, formats, true).format(
        'YYYY-MM-DD',
      );

      return convertedTime;
    }
  }

  return inputValue;
};
